var inherit = require("../general.js").inherit;
var mixin = require("../general.js").mixin;

var Root = require("./root.js");
var GlobalUid = require("./globalUid.js");
var LocalUid = require("./localUid.js");
var JsonParser = require("./jsonParser.js");

// General root for non-persisten editor model
var ModelRoot = function () {
    Root.call(this);

    this.initGlobalUid();   // shouldn't be necessary!
    this.initLocalUid();
    this.initJsonParser();
};
inherit(ModelRoot, Root);
mixin(ModelRoot, GlobalUid, LocalUid, JsonParser);

module.exports = ModelRoot;